import React, {Fragment, useState, useEffect} from 'react'
import * as RouterActions from '../../actions/RouterActions'
import {Table, Popup, Menu, Icon, Loader, Button} from 'semantic-ui-react'
import {useFirebase, useFirestore, useFirestoreConnect} from 'react-redux-firebase';
import {useDispatch, useSelector} from 'react-redux';
import Dropzone from 'react-dropzone';
import * as moment from 'moment'
const filesPath = 'staticfiles'
import {env} from '../../constants/Environment';
import { nanoid } from 'nanoid'
import {StaticfilesNavigation} from './Navigation';
import {default as Fileselect} from './fileselect';

const _ = require('lodash');

export default function Publisher(props) {
    moment.locale('de');
    const firebase = useFirebase()
    const dispatch = useDispatch()
    const [path, setPath] = useState(props.match.params[0].split('/'));
    const firestore = useFirestore();
    const [isLoading, setIsLoading] = useState(false);
    const [lotteries, setLotteries] = useState({});
    const [lottery, setLottery] = useState(null);
    const [channel, setChannel] = useState(null);
    const [selectFileFor, setSelectFileFor] = useState(null);
    const [associatedFiles, setAssociatedFiles] = useState({});

    const fields = [{
        title: 'Rechtliche Hinweise',
        key: 'legal'
    }, {
        title: 'Datenschutzerklärung',
        key: 'data-protection'
    }, {
        title: 'Impressum',
        key: 'imprint'
    }, {
        title: 'Spielerschutz',
        key: 'player-protection'
    }, {
        title: 'Teilnahmebedingungen',
        key: 'conditions-of-participation'
    }];

    useEffect(() => {
        let p = props.match.params[0].split('/');

        if(p[0] !== channel)
            setChannel(p[0]);
        if(p.length > 1 && lottery !== p[1])
            setLottery(p[1]);
        else if(lottery !== null)
            setLottery(null);
        
    }, [props.match.params[0]])


    useEffect(() => {
        if(Object.keys(lotteries).length === 0)
            firestore.collection('environments/' + env + '/lotteries').get().then((data) => {
                let dataToSet = [];

                data.forEach((lotterySnapshot) => {
                    dataToSet[lotterySnapshot.id] = lotterySnapshot.data()
                })

                setLotteries(dataToSet);
            });
    }, [channel, lotteries])

    useEffect(() => {
        if(lottery !== null){
            return firestore.collection('environments/' + env + '/channels/' + channel + '/staticfiles').doc(lottery).onSnapshot((snapshot) => {
                if(snapshot.exists)
                    setAssociatedFiles(snapshot.data());
                else
                    setAssociatedFiles({});
            });
        }
    }, [channel, lottery]);

    const onSelectFile = (file) => {
        setIsLoading(true);

        firestore.collection('environments/' + env + '/channels/' + channel + '/staticfiles').doc(lottery).set({
            [selectFileFor]: file
        }, {
            mergeFields: [selectFileFor]
        }).then(() => {
            setSelectFileFor(null);
            setIsLoading(false);
        });
    }

    const removeSelectedFile = (key) => {
        if(confirm('Sind Sie sicher, dass Sie die Zuordnung löschen möchten?')){
            setIsLoading(true);

            firestore.collection('environments/' + env + '/channels/' + channel + '/staticfiles').doc(lottery).set({
                [key]: firestore.FieldValue.delete()
            }, {
                mergeFields: [key]
            }).then(() => {
                setIsLoading(false);
            });
        }
    }

    return (
        <StaticfilesNavigation breadcrumb={[
            {
                'caption': 'Bereitstellen für ' + channel,
                'href': '/staticfiles/publish/' + channel
            },
            ...((lottery === null)?[]:[{
                'caption': (lottery === '_')?'Alle Lotterien':((typeof lotteries[lottery] === 'undefined')?'_':lotteries[lottery].lottery),
                'href': '/staticfiles/publish/' + channel + '/' + lottery
            }])
        ]} active="publish">
            {
            isLoading || (Object.keys(lotteries).length === 0)?
                <Loader active inline />
            :
                <div style={{
                    display: 'flex'
                }}>
                    {
                        (selectFileFor !== null)?
                            <Fileselect path={[]} onCancel={(e) => setSelectFileFor(null)} onSelectFile={onSelectFile} />
                        :null
                    }
                    <div style={{
                        flexGrow: 0,
                        minWidth: '320px'
                    }}>
                        <Menu secondary vertical pointing fluid>
                            <Menu.Item
                                active={lottery !== null && lottery === '_'}
                                name={'Alle Lotterien'}
                                onClick={(e) => {dispatch(RouterActions.push('/staticfiles/publish/' + channel + '/_'))}}
                            />
                        {
                            Object.keys(lotteries).map((lotteryId) => {
                                return (
                                    <Menu.Item
                                        active={lottery !== null && lottery === lotteryId}
                                        name={lotteries[lotteryId].lottery}
                                        onClick={(e) => {dispatch(RouterActions.push('/staticfiles/publish/' + channel + '/' + lotteryId))}}
                                    />
                                )
                            })
                        }                        
                        </Menu>
                    </div>
                    {
                        (lottery === null)?null
                        :(
                        <div style={{
                            flexGrow: 0,
                            margin: '1em'
                        }}>
                            {
                                fields.map((field) => {
                                    return (
                                    <div style={{
                                        display: 'flex'
                                    }}>
                                        <div style={{flexGrow: 0, width: '200px'}}>{field.title}:</div>
                                        <div style={{
                                            flexGrow: 1
                                        }}>{
                                            (typeof associatedFiles[field.key] !== 'undefined')?
                                                <div><a href={associatedFiles[field.key].fileUrl} target="_blank" style={{
                                                    fontWeight: 'bold',
                                                    paddingRight: '1em'
                                                }}>{associatedFiles[field.key].originalName}</a>{'(Stand: ' + moment(associatedFiles[field.key].created.toDate()).format('DD.MM.YYYY, H:mm:ss') + ')'}</div>
                                            :
                                                <div style={{
                                                    fontStyle: 'italic',
                                                    color: '#AAAAAA'
                                                }}>- Keine Datei ausgewählt -</div>
                                            }
                                        </div>
                                        <div style={{
                                            marginLeft: '1em',
                                            marginBottom: '0.5em'
                                        }}>{
                                                (typeof associatedFiles[field.key] !== 'undefined')?
                                                    <Button onClick={(e) => removeSelectedFile(field.key)} size="tiny" color="red" >
                                                        Zuordnung löschen
                                                    </Button>
                                                :null
                                            }
                                            <Button size="tiny" onClick={(e) => setSelectFileFor(field.key)}>Datei auswählen ...</Button>
                                            
                                        </div>
                                    </div>
                                    )
                                })
                            }
                        </div>
                    )}
                </div>
            }
        </StaticfilesNavigation>
    )
}